import { alpha, Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.spacing(1),
  background: alpha(theme.palette.common.white, 0.03),
  [theme.breakpoints.down('md')]: {
    padding: 0,
  },
  '& .MSImageAndBtnContiner': {
    position: 'relative',
  },
  '& .MSExpandBtn': {
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },
  '& .MSImageContiner': {
    width: '100%',
    height: theme.typography.pxToRem(481),
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.divider[8]}`,
    [theme.breakpoints.down('xl')]: {
      height: theme.typography.pxToRem(445),
    },
    [theme.breakpoints.down('lg')]: {
      height: theme.typography.pxToRem(366),
    },
    [theme.breakpoints.down('md')]: {
      height: theme.typography.pxToRem(202),
    },
  },
  '& .MSTextContainer': {
    padding: theme.spacing(3, 2),
    display: 'flex',
    gap: theme.spacing(3),
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3, 1),
    },
  },
}));
export default StyledBox;
